import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { SpectraChartPoint } from '../hooks/useSpectraChartData';

type SpectraPsdChartProps = {
  data: SpectraChartPoint[];
  logScale: boolean;
};

export function SpectraPsdChart({ data, logScale }: SpectraPsdChartProps) {
  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='frequency' />
          <YAxis />
          <Tooltip />
          <Legend />
          <Area
            type='monotone'
            dataKey='power'
            name={logScale ? 'PSD Welch (log10)' : 'PSD Welch'}
            stroke='#2563eb'
            fill='rgba(37,99,235,0.25)'
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
